module.exports = __webpack_public_path__ + "img/Alert.3c26de1b.svg";